import { render, staticRenderFns } from "./HomeHistory.vue?vue&type=template&id=49461658&scoped=true&"
import script from "./HomeHistory.vue?vue&type=script&lang=js&"
export * from "./HomeHistory.vue?vue&type=script&lang=js&"
import style0 from "./HomeHistory.vue?vue&type=style&index=0&id=49461658&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49461658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49461658')) {
      api.createRecord('49461658', component.options)
    } else {
      api.reload('49461658', component.options)
    }
    module.hot.accept("./HomeHistory.vue?vue&type=template&id=49461658&scoped=true&", function () {
      api.rerender('49461658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeHistory.vue"
export default component.exports